import type { Dayjs } from './dayjs';

/**
 * Rounds a datetime to the nearest minute interval (e.g., 15 min).
 * Used so start_at values match the admin backend DateAndTime dropdown options
 * (00:00:00, 00:15:00, 00:30:00, ...).
 */
export const roundToMinutesInterval = (
  dateTime: Dayjs,
  intervalMinutes: number = 15,
): Dayjs => {
  const copy = dateTime.clone();
  const roundedMinutes = Math.round(copy.minute() / intervalMinutes) * intervalMinutes;

  if (roundedMinutes === 60) {
    const nextHour = copy.add(1, 'hour');
    return nextHour.minute(0).second(0).millisecond(0);
  }

  return copy.minute(roundedMinutes).second(0).millisecond(0);
};
